import React, { type FunctionComponent } from 'react'
import { Section, SectionContent, spacing } from '@retailer-platform/shared-components'
import { css } from '@emotion/react'
import { type DomainMessages, useDomainMessage } from 'domains/collections/utils/domain/intl'

interface Props {
  titleId: DomainMessages
}

const wrapperStyles = css({
  marginBottom: spacing.X32,
})

export const CollectionsViewSection: FunctionComponent<Props> = ({ titleId, children }) => {
  const title = useDomainMessage(titleId)

  return (
    <Section title={title} wrapperStyles={wrapperStyles}>
      <SectionContent>{children}</SectionContent>
    </Section>
  )
}
